import React, { forwardRef, useEffect, useState, useImperativeHandle } from "react";
import { MultiSelect } from "@progress/kendo-react-dropdowns";

let isMultiSelectUpdated = false;

const DashboardMultiSelect = ({ allFilters, filterData, onFilterChange, restClient, loader }, ref) => {
  const [multiSelectOptions, setMultiSelectOptions] = useState([]);
  const [multiSelectValues, setMultiSelectValues] = useState([]);
  const handleMultiSelectChange = (e) => {
    let value = e.value.map((eventVal) => ({ ...eventVal, field: filterData.field, operator: filterData.operator }));
    setMultiSelectValues(value);
    onFilterChange({ ...filterData, value: [...value] });
  };

  const showLoader = () => {
    loader.show(document.getElementsByClassName("customKendoCustomSelect")?.[document.getElementsByClassName("customKendoCustomSelect").length - 1]);
  };

  const destroyLoader = () => {
    loader?.destroy();
  };

  const addLogicBetweenFilter = (array) => {
    const indexOfLastElementInFirstArr = Math.floor(array.length / 2);
    if (indexOfLastElementInFirstArr < 1) return array.flat();
    else {
      const joinFiltersWithLogic = (startingIndex, endingIndex) => {
        return array.slice(startingIndex, endingIndex).reduce((acc, each, index, arr) => {
          arr.length === 1 ? acc.push(...each) : acc.push(each);
          index !== arr.length - 1 && acc.push(filterData.operator === "NOT LIKE" ? "AND" : "OR");
          return acc;
        }, []);
      };
      return [joinFiltersWithLogic(0, indexOfLastElementInFirstArr), filterData.operator === "NOT LIKE" ? "AND" : "OR", joinFiltersWithLogic(indexOfLastElementInFirstArr, array.length)];
    }
  };

  useImperativeHandle(ref, () => ({
    getMultiSelectValues: () => {
      let extractedMultiSelectFilters = [];
      if (filterData.value.length > 0) {
        filterData.value.map((multiSelectValue, index) => {
          let eachFilter = [];
          //format for select filter when it is selected as defailt filter is not proper when coming from filter configuration
          if (filterData.value[0].operator) {
            eachFilter.push(multiSelectValue.text, multiSelectValue.operator, multiSelectValue.field);
          } else {
            eachFilter.push(multiSelectValue.value, filterData.operator, filterData.field);
          }
          extractedMultiSelectFilters.push(eachFilter.reverse());
          // index !== filterData.value.length - 1 && extractedMultiSelectFilters.push("OR");
        });
        if (extractedMultiSelectFilters.length === 1) {
          return extractedMultiSelectFilters;
        } else if (extractedMultiSelectFilters.length > 1) {
          return [addLogicBetweenFilter(extractedMultiSelectFilters)];
        }
        // return extractedMultiSelectFilters.length >= 1 ? [addLogicBetweenFilter(extractedMultiSelectFilters, "OR")] : extractedMultiSelectFilters;
        // return extractedMultiSelectFilters.length > 1 ? extractedMultiSelectFilters : extractedMultiSelectFilters;
      }
    },
  }));

  const getMultiSelectDropDownOptions = async (field) => {
    showLoader();
    let dropDownFilter = allFilters.filter((filter) => filter?.field === field)[0];
    let datasource_id = dropDownFilter["filterDataSource"];
    let filter_index = dropDownFilter["filterIndex"];
    let filterQuery = dropDownFilter["filterQuery"];
    let baseUrl = `analytics/datasource/${datasource_id}/getdetails?type=values&index=${filter_index}&field=${filterData.field}`;
    if (filterQuery) {
      baseUrl = `${baseUrl}&filter=${filterQuery}`;
    }
    const response = await restClient.request("v1", baseUrl, {}, "get");
    if (response.status === "success") {
      //preparing options for react-select component
      if (response.data && typeof response.data == "object" && response.data.length > 0) {
        let preparedFilterOption = [];
        response.data.map((filterName) => {
          preparedFilterOption.push({ text: filterName, operator: "==" });
        });
        isMultiSelectUpdated = true;
        setMultiSelectOptions(preparedFilterOption);
      }
    }
  };

  useEffect(() => {
    let invalidFormat = filterData?.value?.some((filter) => filter.label);
    if (invalidFormat) {
      const newValues = filterData.value.map((filter) => ({
        operator: filterData.operator,
        field: filterData.field,
        text: filter.label,
      }));
      setMultiSelectValues(newValues);
    } else if (filterData.value) {
      setMultiSelectValues(filterData.value);
    }
    getMultiSelectDropDownOptions(filterData.field);
  }, [filterData.field]);

  useEffect(() => {
    // is there any other way to do this? 🤔
    // doing this to so that loader gets destroyed when the state updates only from one place
    if (isMultiSelectUpdated) {
      destroyLoader();
      isMultiSelectUpdated = false;
    }
  }, [multiSelectOptions]);

  return (
    <>
      <MultiSelect
        className="customKendoCustomSelect"
        data={multiSelectOptions?.length > 0 ? multiSelectOptions : [{ text: "Loading", operator: "==" }]}
        textField="text"
        dataItemKey="text" //!if name is same both names will get selected and break the component
        onChange={(e) => handleMultiSelectChange(e, filterData.field)}
        value={multiSelectValues}
        placeholder={`Select ${filterData.field}`}
      />
    </>
  );
};

export default forwardRef(DashboardMultiSelect);
